import { render, staticRenderFns } from "./useCase.vue?vue&type=template&id=32a77131&scoped=true&"
import script from "./useCase.vue?vue&type=script&lang=js&"
export * from "./useCase.vue?vue&type=script&lang=js&"
import style0 from "./useCase.vue?vue&type=style&index=0&id=32a77131&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a77131",
  null
  
)

export default component.exports